var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.668 14.2242C9.7762 14.2242 9.86895 14.2319 9.94623 14.2474C10.1472 14.2783 10.2477 14.4638 10.2477 14.8038H4.75244V14.2242C5.13888 14.2242 5.44031 14.201 5.65672 14.1546C6.15136 14.0155 6.39869 13.5981 6.39869 12.9025V5.48283H4.75244V4.90316H8.6246V14.2242H9.668ZM8.87965 1.65704C8.87965 1.88891 8.83328 2.10532 8.74053 2.30627C8.47775 2.83183 8.03721 3.09461 7.4189 3.09461C7.20249 3.09461 6.99381 3.04824 6.79286 2.95549C6.25184 2.70817 5.98133 2.27535 5.98133 1.65704C5.98133 1.42518 6.03543 1.20104 6.14364 0.984633C6.40642 0.45907 6.8315 0.196289 7.4189 0.196289C7.65076 0.196289 7.8749 0.250391 8.09131 0.358595C8.61687 0.636834 8.87965 1.06965 8.87965 1.65704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.884037bc4e7d42fc13db6b0596ee1939.svg";
export { ForwardRef as ReactComponent };